import React, { createContext, useReducer, useCallback } from "react";

import searchReducer from "../../reducers/search/searchReducer";

const initialState = {
  // ================= BOOKINGS =================
  bookingsearch: {
    sn: "",
    name: "",
    fileRef: "",
    interpreterName: "",
    serviceType: "",
    language: "",
    dialect: "",
    companyName: "",
    clientName: "",
    status: "",
    page: 1,
    limit: 50,
  },

  // ================= INTERPRETERS =================
  interpreterSearch: {
    fname: "",
    language: "",
    dialect: "",
    gender: "",
    service: "",
    postcode: "",
    active: "",
    page: 1,
    limit: 50,
  },

  // ================= RECRUITMENTS =================
  recruitmentSearch: {
    recId: "",
    name: "",
    email: "",
    contactNumber: "",
    language: "",
    dialect: "",
    service: "",
    gender: "",
    nationality: "",
    statusInUk: "",

    // false = hide duplicates
    hasDuplicates: false,

    page: 1,
    limit: 50,
  },

  loading: false,
};

// ================= CLEAN OBJECT =================
const cleanObj = (obj) => {
  const cleaned = { ...obj };

  Object.keys(cleaned).forEach((key) => {
    if (
      cleaned[key] === null ||
      cleaned[key] === undefined ||
      cleaned[key] === "" ||
      cleaned[key] === "none"
    ) {
      delete cleaned[key];
    }
  });

  return cleaned;
};

// ================= QUERY BUILDER =================
const buildQuery = (params) =>
  Object.entries(params)
    .map(
      ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`,
    )
    .join("&");

export const SearchContext = createContext(initialState);

export const SearchProvider = ({ children }) => {
  const [state, dispatch] = useReducer(searchReducer, initialState);

  // ================= BOOKINGS =================
  const bookingSearchHandler = useCallback((obj) => {
    const params = cleanObj(obj);

    dispatch({
      type: "SEARCH_BOOKINGS",
      payload: obj,
    });

    return buildQuery(params);
  }, []);

  // ================= INTERPRETERS =================
  const interpreterSearchHandler = useCallback((obj) => {
    const params = cleanObj(obj);

    dispatch({
      type: "SEARCH_INTERPRETER",
      payload: obj,
    });

    return buildQuery(params);
  }, []);

  // ================= RECRUITMENTS =================
  const recruitmentSearchHandler = useCallback((obj) => {
    const params = cleanObj(obj);

    return buildQuery(params);
  }, []);

  // ================= CLEAR SEARCH =================
  const clearBookingsSearchHandler = useCallback(() => {
    dispatch({
      type: "CLEAR_BOOKING",
    });
  }, []);

  const clearInterpretersSearchHandler = useCallback(() => {
    dispatch({
      type: "CLEAR_ALL_INERPRETER",
    });
  }, []);

  const clearRecruitmentsSearchHandler = useCallback(() => {
    dispatch({
      type: "CLEAR_RECRUITMENTS",
    });
  }, []);

  return (
    <SearchContext.Provider
      value={{
        // BOOKINGS
        bookingSearch: state?.bookingsearch,
        bookingSearchHandler,
        clearBookingsSearchHandler,

        // INTERPRETERS
        interpreterSearch: state?.interpreterSearch,
        interpreterSearchHandler,
        clearInterpretersSearchHandler,

        // RECRUITMENTS
        recruitmentSearch: state?.recruitmentSearch,
        recruitmentSearchHandler,
        clearRecruitmentsSearchHandler,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
